import script from "./DocumentViewPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentViewPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentViewPage.vue?vue&type=style&index=0&id=6b1fd694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1fd694"]])

export default __exports__